export default "__VITE_ASSET__Ckw$6oMz__"